import React from "react";

const ApproversDetails = ({
  id_R,
  closeApproversDetailsOpen,
  isApproversDetailsOpen,
  requestApprovals,
}) => {
  console.log("requestApprovals", requestApprovals);

  return (
    <>
      <div
        id={id_R}
        className={`${
          isApproversDetailsOpen ? "flex" : "hidden"
        } items-center justify-center fixed inset-0 z-50 overflow-auto bg-gray-800 bg-opacity-50`}
      >
        <div className="relative flex items-center fixed min-h-screen w-[60%] max-w-[100%] h-full md:h-auto">
          <div className="relative justify-end bg-white shadow  w-[100%] mx-auto h-[80vh] px-4">
            <div className="justify-end rounded-t flex items-end">
              <button
                onClick={closeApproversDetailsOpen}
                type="button"
                className="bg-transparent rounded-lg text-sm p-2.5 ml-auto inline-flex items-center"
                data-modal-toggle={id_R}
              >
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.84 12L5.7 8.9L3.9 12H0.2L3.88 6.3L0.1 0.839999H3.94L6.08 3.92L7.88 0.839999H11.58L7.84 6.46L11.68 12H7.84Z"
                    fill="black"
                  />
                </svg>
              </button>
            </div>

            <div className="flex items-center mt-5">
              <p className="text-[#000000] text-[20px] font-[700]">
                Approval Details
              </p>
            </div>
            <div className="flex items-center mt-5">
              <p className="font-[300] text-[15px] text-[#000000]">
                View the details of approvers, including their User ID, name,
                and approval time.
              </p>
            </div>

            <div className="h-[48vh] overflow-y-auto mt-2">
              <>
                <div className="h-[44px] w-full text-[14px] font-[400] px-[20px] flex items-center mt-[10px] bg-[#F0FFFE]">
                  <p className="w-[20%] !m-0 !p-0"> User ID</p>
                  <p className="w-[25%] !m-0 !p-0">Name</p>
                  <p className="w-[42%] !m-0 !p-0">Email</p>
                  <p className="w-[25%] !m-0 !p-0">Phone Number</p>
                  <p className="w-[30%] !m-0 !p-0">Approval Time</p>
                </div>

                {requestApprovals?.length > 0 ? (
                  requestApprovals?.map((approver, index) => (
                    <div
                      key={index}
                      className="h-[44px] w-full px-[20px] flex items-center mt-[10px]"
                    >
                      <p className="w-[20%] text-[#06B217] font-[500] text-[14px]">
                        {approver?.admin?.public_id || "N/A"}
                      </p>

                      <p className="w-[25%]">
                        {approver?.admin
                          ? `${approver?.admin?.firstname} ${approver?.admin?.lastname}`
                          : "No Admin"}
                      </p>

                      <p className="w-[42%]">
                        {approver?.admin?.email || "N/A"}
                      </p>

                      <p className="w-[25%]">
                        {approver?.admin?.phone || "N/A"}
                      </p>
                      <p className="w-[30%]">
                        {new Date(approver?.createdAt).toLocaleString()}
                      </p>
                    </div>
                  ))
                ) : (
                  <p className="text-center text-gray-700 mt-4 text-lg font-bold flex justify-center items-center h-32">
                    No approval records for this loan found.
                  </p>
                )}
              </>
            </div>

            <div className="flex items-center justify-center mx-5">
              <button
                onClick={closeApproversDetailsOpen}
                data-modal-toggle={id_R}
                type="button"
                className="text-[#074073] bg-[#FFFFFF] hover:bg-[#FFFFFF] border border-[#074073] focus:outline-none font-[500] rounded-[5px] text-[16px] text-medium px-16 py-2 text-center"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ApproversDetails;
